/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UptimePreferenceResponse
 */
export interface UptimePreferenceResponse {
    /**
     *
     * @type {boolean}
     * @memberof UptimePreferenceResponse
     */
    value?: boolean;
    /**
     *
     * @type {Date}
     * @memberof UptimePreferenceResponse
     */
    updatedAt?: Date;
    /**
     *
     * @type {number}
     * @memberof UptimePreferenceResponse
     */
    updatedByUserAccountId?: number;
}

/**
 * Check if a given object implements the UptimePreferenceResponse interface.
 */
export function instanceOfUptimePreferenceResponse(
    value: object,
): value is UptimePreferenceResponse {
    return true;
}

export function UptimePreferenceResponseFromJSON(
    json: any,
): UptimePreferenceResponse {
    return UptimePreferenceResponseFromJSONTyped(json, false);
}

export function UptimePreferenceResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UptimePreferenceResponse {
    if (json == null) {
        return json;
    }
    return {
        value: json["value"] == null ? undefined : json["value"],
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        updatedByUserAccountId:
            json["updatedByUserAccountId"] == null
                ? undefined
                : json["updatedByUserAccountId"],
    };
}

export function UptimePreferenceResponseToJSON(
    value?: UptimePreferenceResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        value: value["value"],
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        updatedByUserAccountId: value["updatedByUserAccountId"],
    };
}
